(function () {
  const KODIF_IFRAME_ID = 'kodif-chat-widget';

  function isAskQuestionButton(button) {
    if (!button) return false;

    const wrapper = button.closest('.product__block--addons');
    if (!wrapper) return false;

    const label = (button.textContent || '').trim().toLowerCase();
    return label.includes('ask a question');
  }

  function openKodifChat() {
    const iframe = document.getElementById(KODIF_IFRAME_ID);

    if (!iframe) {
      console.warn('KODIF iframe not found.');
      return false;
    }

    const originalSrc =
      iframe.dataset.kodifOriginalSrc ||
      iframe.getAttribute('src');

    if (!originalSrc) {
      console.warn('KODIF iframe has no src.');
      return false;
    }

    iframe.dataset.kodifOriginalSrc = originalSrc;

    try {
      const url = new URL(originalSrc, window.location.origin);

      // Force widget open state
      url.searchParams.set('open', 'true');

      // Force refresh every click so it works repeatedly
      url.searchParams.set('_kodifTrigger', Date.now().toString());

      iframe.src = url.toString();
      return true;
    } catch (error) {
      console.warn('Unable to update KODIF iframe src.', error);
      return false;
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      const button = event.target.closest('button');
      if (!isAskQuestionButton(button)) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      // Try to shut the existing modal if theme already wired it up
      const modalId = button.getAttribute('aria-controls');
      if (modalId) {
        const modal = document.getElementById(modalId);
        if (modal) {
          modal.removeAttribute('open');
          modal.classList.remove('active', 'is-open', 'open');
          modal.setAttribute('aria-hidden', 'true');
        }
      }

      openKodifChat();
    },
    true
  );
})();